module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "mod"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('img', {
    staticClass: "layer",
    attrs: {
      "src": "static/img/7.png",
      "data-src": "static/img/7.png",
      "alt": "layer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row1"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.receive1 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(1)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive1 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey1 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row2"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.receive2 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(2)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive2 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey2 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row2"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.receive3 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(3)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive3 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey3 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row4"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), (_vm.receive4 === false) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_1"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(4)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive4 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey4 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row5"
  }, [_vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), (_vm.receive5 === false) ? _c('img', {
    staticClass: "largeIcon_10 icon",
    attrs: {
      "src": "static/img/领取.png",
      "data-src": "static/img/领取.png",
      "alt": "largeIcon_10"
    },
    on: {
      "click": function($event) {
        return _vm.receivePrize(5)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.receive5 === true) ? _c('img', {
    staticClass: "largeIcon_10 icon",
    attrs: {
      "src": "static/img/已领取.png",
      "data-src": "static/img/已领取.png",
      "alt": "largeIcon_10"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.grey5 === true) ? _c('img', {
    staticClass: "largeIcon_1 icon",
    attrs: {
      "src": "static/img/领取灰.png",
      "data-src": "static/img/领取灰.png",
      "alt": "largeIcon_1"
    }
  }) : _vm._e()])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "group_6"
  }, [_c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("\n            返回首页\n           ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_2"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "static/img/6.png",
      "data-src": "static/img/6.png",
      "alt": "largeIcon"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_2"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('span', {
    staticClass: "text_2"
  }, [_vm._v("G客")]), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v("精美台历")])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("礼品将在回款后为您寄出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block_4"
  }, [_c('img', {
    staticClass: "largeIcon_2",
    attrs: {
      "src": "static/img/5.png",
      "data-src": "static/img/5.png",
      "alt": "largeIcon_2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group_3"
  }, [_c('div', {
    staticClass: "block_5"
  }, [_c('span', {
    staticClass: "word_2"
  }, [_vm._v("G客")]), _vm._v(" "), _c('span', {
    staticClass: "text_3"
  }, [_vm._v("U盘32G")])]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("礼品将在回款后为您寄出")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_3"
  }, [_c('img', {
    staticClass: "largeIcon_3",
    attrs: {
      "src": "static/img/4.png",
      "data-src": "static/img/4.png",
      "alt": "largeIcon_3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "group_4"
  }, [_c('span', {
    staticClass: "txt_2"
  }, [_vm._v("病毒")]), _vm._v(" "), _c('span', {
    staticClass: "word_3"
  }, [_vm._v("300元")]), _vm._v(" "), _c('span', {
    staticClass: "text_4"
  }, [_vm._v("优惠券")])]), _vm._v(" "), _c('span', {
    staticClass: "desc_3"
  }, [_vm._v("无门槛优惠券，有效期1个月")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block_6"
  }, [_c('img', {
    staticClass: "largeIcon_4",
    attrs: {
      "src": "static/img/3.png",
      "data-src": "static/img/3.png",
      "alt": "largeIcon_4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_4"
  }, [_c('div', {
    staticClass: "group_4"
  }, [_c('span', {
    staticClass: "txt_2"
  }, [_vm._v("蛋白组学")]), _vm._v(" "), _c('span', {
    staticClass: "word_3"
  }, [_vm._v("1314元")]), _vm._v(" "), _c('span', {
    staticClass: "text_4"
  }, [_vm._v("券")])]), _vm._v(" "), _c('span', {
    staticClass: "desc_3"
  }, [_vm._v("合同金额5万以上可使用")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_5"
  }, [_c('div', {
    staticClass: "outer_5"
  }, [_c('img', {
    staticClass: "news",
    attrs: {
      "src": "static/img/2.png",
      "data-src": "static/img/2.png",
      "alt": "news"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer_6"
  }, [_c('span', {
    staticClass: "info_2"
  }, [_vm._v("m6A高级生信分析券")]), _vm._v(" "), _c('span', {
    staticClass: "info_3"
  }, [_vm._v("满4个样本免费分析")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "text_6"
  }, [_vm._v("活动规则")]), _vm._v(" "), _c('span', {
    staticClass: "article"
  }, [_vm._v("\n            1、所选礼品在您该笔订单回款后5个工作日内安排发货。"), _c('br'), _vm._v("\n            2、m6A高级生信分析券，满4个样本的m6A测序合同，签订且到样后即可使用，有效期至2021年2月28日。可添加专属客服：jikaikefu使用该券。"), _c('br'), _vm._v("\n            3、蛋白组学1314元代金券，限合同目录价金额大于5万的蛋白组学合同使用，在目录价上抵扣，有效期至2021年2月28日。可添加专属客服：jikaikefu使用该券。"), _c('br'), _vm._v("\n            4、病毒代金券有效期自领取12小时后起1个月内有效，所有病毒都可使用。限在淘基因商城下单，该代金券可叠加日常折扣使用。"), _c('br'), _vm._v("\n            5、该折扣优惠与其他优惠券和会员折扣不同享。\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6bbc412","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Order/SuccessPay2.vue
// module id = 1740
// module chunks = 8